import request from '@/utils/request'

const base = '/ai-analysis-history'

export default {
  overview(params = {}) {
    return request({ url: `${base}/overview`, method: 'get', params })
  },
  errorAnalysis(params = {}) {
    return request({ url: `${base}/error-analysis`, method: 'get', params })
  },
  history(data = {}) {
    return request({ url: `${base}/history`, method: 'post', data })
  },
  trendDaily(params = {}) {
    return request({ url: `${base}/trend/daily`, method: 'get', params })
  },
  suggestions(params = {}) {
    return request({ url: `${base}/suggestions`, method: 'get', params })
  },
  suggestionApprove(data = {}) {
    return request({ url: `${base}/suggestions/approve`, method: 'post', data })
  },
  suggestionApply(data = {}) {
    return request({ url: `${base}/suggestions/apply`, method: 'post', data })
  },
  suggestionIgnore(data = {}) {
    return request({ url: `${base}/suggestions/ignore`, method: 'post', data })
  },
  // 轨迹查询（若后端未实现，将由前端兜底）
  getTrace(historyId) {
    return request({ url: `${base}/history/${historyId}/trace`, method: 'get' })
  }
}


